import { useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { useTypedTranslations } from "hooks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    merchantCard: {
      height: "fit-content",
      display: "flex",
      flexDirection: "column",
    },
    merchLogo: {
      width: "100%",
      height: "175px",
      borderBottom: "2px solid black",
      objectFit: "cover",
    },
    merchTitle: {
      textAlign: "center",
      fontSize: "20px",
      fontWeight: "bold",
      textTransform: "uppercase",
      padding: "0.8em",
    },
    titleDivider: {
      alignSelf: "center",
      backgroundColor: theme.palette.primary.main,
      height: "4px",
      borderRadius: "2px",
      width: "30%",
    },
    merchDescr: {
      padding: "1em",
    },
    manageButton: {
      margin: "1em 0",
      width: "fit-content",
      alignSelf: "center",
      borderRadius: "20px",
    },
  }),
);

const useMerchCard = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();
  const [t] = useTypedTranslations();

  return {
    styles,
    classes,
    atomicStyles,
    t,
  };
};

export { useMerchCard as default };
